import type { SalesStage } from '../types/contracts';
import { STAGE_LABEL } from '../lib/format';

const STAGE_CLS: Record<SalesStage, string> = {
  new: 'bg-gray-50 text-gray-600 border-gray-200',
  contacted: 'bg-sky-50 text-sky-700 border-sky-100',
  qualified: 'bg-indigo-50 text-indigo-700 border-indigo-100',
  demo: 'bg-violet-50 text-violet-700 border-violet-100',
  trial: 'bg-amber-50 text-amber-700 border-amber-100',
  negotiation: 'bg-orange-50 text-orange-700 border-orange-100',
  won: 'bg-emerald-50 text-emerald-700 border-emerald-100',
  lost: 'bg-gray-100 text-gray-500 border-gray-200',
};

export function LeadStage({ stage }: { stage: SalesStage }) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[10px] font-bold ${STAGE_CLS[stage]}`}>
      {STAGE_LABEL[stage]}
    </span>
  );
}

export function JourneyPipeline({ journey }: { journey: { stage: SalesStage; state: 'done' | 'current' | 'upcoming' }[] }) {
  return (
    <ol className="space-y-1">
      {journey.map((j) => (
        <li key={j.stage} className="flex items-center gap-2 text-xs">
          <span className={`w-4 h-4 rounded-full flex items-center justify-center text-[9px] font-black ${
            j.state === 'done' ? 'bg-teal-600 text-white' : j.state === 'current' ? 'bg-amber-400 text-white' : 'bg-gray-100 text-gray-400'
          }`}>
            {j.state === 'done' ? '✓' : j.state === 'current' ? '●' : '?'}
          </span>
          <span className={j.state === 'upcoming' ? 'text-gray-400' : 'font-semibold text-gray-800'}>{STAGE_LABEL[j.stage]}</span>
        </li>
      ))}
    </ol>
  );
}
